import App from './views/App.vue';
import router from './routes';

import AkApprovalStatusSelect from "./widgets/AkApprovalStatusSelect.vue";
import CloudColorPicker from "./widgets/CloudColorPicker.vue";


Vue.component('ak-approval-status-select', AkApprovalStatusSelect);
Vue.component('cloud-color-picker', CloudColorPicker);

let app = new Vue({
        data() { 
            return {
                globalMessages: []
            }
        },
        router,
        render: h => h(App),
}).$mount('#app')

AppKit.init(app);
